import type React from "react";
import type { DirectoryCard } from "@frontend/shared/domain/types/directory-card.types";
import { AISummarySection } from "./AISummarySection";
import { BioSection } from "./BioSection";
import { LinkedInSection } from "./LinkedInSection";

export interface ProfileTabContentProps {
  readonly entry: DirectoryCard;
  readonly isOwnProfile?: boolean;
}

export function ProfileTabContent({
  entry,
  isOwnProfile = false,
}: ProfileTabContentProps): React.JSX.Element {
  return (
    <div className="flex flex-col gap-8 pt-4">
      {entry.bio !== null &&
        (entry.isBioAIGenerated ? (
          <AISummarySection summary={entry.bio} />
        ) : (
          <BioSection bio={entry.bio} />
        ))}

      <LinkedInSection summary={entry.summary} isOwnProfile={isOwnProfile} />
    </div>
  );
}
